module.exports = __webpack_public_path__ + "img/vindkraftverk.0a2f0c9f.jpg";